module.exports = "/assets/data/cefb1886686c9ebdc2706a7181c0832b-SW1H.data.json";